import { IconButton, Menu, MenuItem } from "@mui/material"
import { useRef, useState } from "react"
import { prevent } from "lib/prevent"
import noop from "lib/noop"
import { EditField } from "event-definitions"
import { deriveGuidFrom, generate } from "library/guid"
import { indexAuthoringTasksInSchedule } from "./lib/index-authoring-tasks-in-schedule"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useScheduleEditorActions } from "./hooks/use-schedule-editor-actions"
import Iconify from "minimals-template/components/Iconify"

export function AuthoringAddTaskButton() {
    const { schedule, task } = useBoundContext()
    const { notifyDraftStructureChanged } = useScheduleEditorActions()
    const [anchor, setAnchor] = useState(null)
    const buttonRef = useRef()

    return (
        <>
            <IconButton
                aria-label="Add task"
                className="add-task"
                data-cy="add-task"
                ref={buttonRef}
                color="primary"
                size="small"
                onClick={prevent(() => setAnchor(buttonRef.current))}
            >
                <Iconify icon="mdi:add" />
            </IconButton>

            <Menu onClick={prevent(noop)} open={!!anchor} anchorEl={anchor} onClose={() => setAnchor(null)}>
                <MenuItem onClick={addTask} data-cy="add-task-add-task">
                    Add Task
                </MenuItem>
                <MenuItem onClick={addHeader} data-cy="add-task-add-header">
                    Add Header
                </MenuItem>
            </Menu>
        </>
    )

    function syncTasks() {
        const scheduleId = schedule?.id
        if (!scheduleId || !Array.isArray(schedule?.tasks)) return
        let h = 0
        let t = 0
        for (let i = 0; i < schedule.tasks.length; i++) {
            const task = schedule.tasks[i]
            const { isHeader } = task
            task.id = `${scheduleId}.${isHeader ? `HH${h++}` : `${t++}`}`
            task.index = i
        }
    }

    function createGuid() {
        return deriveGuidFrom(generate())
    }

    function addTask() {
        const newTask = {
            taskId: createGuid(),
            classification: "Amber",
            frequency: {
                period: "Unknown",
                interval: 0,
            },
            title: "New task",
            note: "",
            content: "",
            isHeader: false,
            unitOfMeasure: "Nr",
            skillSet: "1",
        }
        if (task) {
            schedule.tasks.splice(task.$sort + 1, 0, newTask)
        } else {
            schedule.tasks.push(newTask)
        }
        syncTasks()
        indexAuthoringTasksInSchedule(schedule)
        notifyDraftStructureChanged?.()
        setAnchor(null)
        EditField.raiseLater({ target: newTask, field: "title" })
    }

    function addHeader() {
        const newTask = {
            taskId: createGuid(),
            title: "New header",
            isHeader: true,
        }
        if (task) {
            schedule.tasks.splice(task.$sort + 1, 0, newTask)
        } else {
            schedule.tasks.push(newTask)
        }
        syncTasks()
        indexAuthoringTasksInSchedule(schedule)
        notifyDraftStructureChanged?.()
        setAnchor(null)
        EditField.raiseLater({ target: newTask, field: "title" })
    }
}
